import { useTranslation } from 'next-i18next'

import { useGetCurriculumCountriesQuery } from '~/curriculum/apis/curriculum.api'
import { CurriculumCountryNames } from '~/curriculum/constants/curriculum.const'
import { getOrderedUsCurriculumStates } from '~/curriculum/constants/usCurriculumStates.const'

/** The curriculums that live inside the USA group rather than as top-level rows. */
const US_GROUPED_CURRICULUM_NAMES: string[] = [
  CurriculumCountryNames.USA,
  CurriculumCountryNames.CALIFORNIA_CCSSM,
  CurriculumCountryNames.FLORIDA,
]

export default function SettingsCurriculumOptions({
  chosenCurriculum,
}: {
  chosenCurriculum?: string
}): React.ReactElement {
  const { t } = useTranslation('settings')
  const { data: curriculumCountriesData } = useGetCurriculumCountriesQuery()
  const availableCountryCodes = new Set((curriculumCountriesData ?? []).map(({ countryCode }) => countryCode))
  // Everything not under the USA group stays a flat option (Norge, Українська, Philippines, ...)
  const countries: string[] = (curriculumCountriesData ?? [])
    .map(({ country }) => country)
    .filter((country) => !US_GROUPED_CURRICULUM_NAMES.includes(country))
  const usStates = getOrderedUsCurriculumStates(availableCountryCodes)

  // An empty or unmatched <select> value would show the first option (Norge); this is the single placeholder.
  const isChosenCurriculumOffered = Boolean(
    chosenCurriculum &&
      (countries.includes(chosenCurriculum) || usStates.some((state) => state.curriculumName === chosenCurriculum)),
  )

  return (
    <>
      {!isChosenCurriculumOffered && <option value="">{t('chooseCurriculum')}</option>}
      {countries.map((country) => (
        <option key={country} value={country}>
          {country}
        </option>
      ))}
      <optgroup label={CurriculumCountryNames.USA}>
        {usStates.map((state) => (
          <option key={state.label} value={state.curriculumName}>
            {state.label}
          </option>
        ))}
      </optgroup>
    </>
  )
}
